var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.ncgFormat(_vm.decimalAmount))+" "),_c('span',{staticClass:"ticker"},[_vm._v(_vm._s(_vm.ticker))])])
}
var staticRenderFns = []

export { render, staticRenderFns }